import React, { Component } from "react";
import PropTypes from "prop-types";
import html2pdf from "html2pdf-fix-jspdf";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { connect } from "react-redux";
import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import Lists from "@material-ui/icons/List";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import { pushLoader } from "../../actions/main";
import { pushCctvMap, pushCctvhistoris } from "../../actions/dashboard";
import { fetchSearchCctvactreport } from "../../api/portal";
import moment from "moment";
import { NavLink, withRouter } from "react-router-dom";
import NavPills from "components/NavPills/NavPills2.jsx";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import Tooltip from "@material-ui/core/Tooltip";
import Arrivallist from "./arrivallist";
import Departurelist from "./departurelist";
import Tabinfo from "./tabinfo";
import Tabtrack from "./tabtrack";
import Voyage from "./voyage";
import Image from "../../assets/img/default.png";

// import api
import {
  fetchVesselDetailMT,
  pushFavorite,
  fetchVesselbyship_id,
  fetchIpman,
  fetchIMIS
} from "../../api/portal";
import { fetchVessellistSearch } from "../../api/vessellist";
import _ from "lodash";

const NewTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: "#FFD700",
    color: "black",
    fontSize: 11
  }
}))(Tooltip);

const styles = theme => ({
  container: {
    position: "relative",
    width: "100%",
    "& $image:hover": {
      opacity: 0.3
    },
    "& $middle:hover": {
      opacity: 1
    }
  },
  image: {
    opacity: 1,
    display: "block",
    width: "100%",
    height: "200px",
    transition: ".5s ease",
    backfaceVisibility: "hidden"
  },
  middle: {
    transition: ".5s ease",
    opacity: 0,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    msTransform: "translate(-50%, -50%)",
    textAlign: "center"
  },
  text: {
    backgroundColor: "#4287f5",
    color: "white",
    fontSize: "16px",
    padding: "16px 32px"
  }
});

let data = [];

class Rightpanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      baloonTitle: "",
      dialogVoyage: false,
      tabval: 0,
      dataVoyage: [],
      tabnya: [],
      report: false,
      load: false,
      buttonvoyage: false,
      startdate: "",
      enddate: "",
      alertVoyage: true,
      alertText: ""
    };
  }

  UNSAFE_componentWillMount() {}

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ open: false });
    let str = "-";
    if (typeof nextProps.ship_id != "undefined") {
      if (nextProps.ship_id.length <= 8) {
        str = nextProps.ship_id;
      }
    }

    let datanya = nextProps.allStateMapmaster;

    if (datanya != null) {
      this.setState({ alertVoyage: true });
      fetchIMIS(datanya.call_sign)
        // fetchIMIS("YFDE")
        .then(response => {
          let totaltdata = response.data;

          if (totaltdata.count == 0) {
            this.setState({ buttonvoyage: false });
          } else {
            this.setState({ buttonvoyage: true });

            this.props.pushLoader(false);
            if (response.data.results.length != 0) {
              let dateAlert = moment(
                response.data.results[0].CompletedAt
              ).format("DD-MM-YYYY HH:mm:ss");
              let today = moment().format("DD-MM-YYYY HH:mm:ss");

              if (dateAlert < today) {
                this.setState({
                  alertVoyage: false,
                  alertText: "Data is not updated yet from IMIS"
                });
              }

              this.setState({
                report: true,
                load: true,
                dataVoyage: response.data.results,
                modified: response.data.results[0].modified,
                shipnumber: response.data.results[0].shipnumber,
                voyage_number: response.data.results[0].voyage_number,
                shipment_detailID: response.data.results[0].shipment_detailID,
                dwt: response.data.results[0].dwt,
                startdate: response.data.results[0].CommencedAt,
                enddate: response.data.results[0].CompletedAt
              });
            } else {
              this.setState({
                dataVoyage: [],
                report: false,
                load: true,
                alertVoyage: false,
                alertText: "No Data from IMIS"
              });
            }
          }
        })
        .catch(error => {
          console.log(error);
          //this.props.history.push("/pages/login#logout");
        });
    }

    if (datanya) {
      this.setState({
        baloonTitle: datanya.baloonTitle,
        jenis: datanya.jenis,
        call_sign: datanya.call_sign,
        name: datanya.name,
        hdg: datanya.hdg,
        typenya: datanya.typenya,
        geomtype: datanya.geomtype,
        course: datanya.course,
        elapsed: datanya.elapsed,
        heading: datanya.heading,
        lat: datanya.lat,
        lon: datanya.lon,
        weather: datanya.weather,
        temp: datanya.temp,
        shipname: datanya.shipname,
        ship_id: datanya.ship_id,
        ship_idx: str,
        type_img: datanya.type_img,
        type_name: datanya.type_name,
        id: datanya.id,
        speed: datanya.speed,
        status_name: datanya.status_name,
        Tanggal: datanya.Tanggal,
        Jam: datanya.Jam,
        DateTime: datanya.DateTime,
        Lintang: datanya.Lintang,
        Bujur: datanya.Bujur,
        Magnitude: datanya.Magnitude,
        Kedalaman: datanya.Kedalaman,
        Wilayah: datanya.Wilayah,
        Potensi: datanya.Potensi,
        Dirasakan: datanya.Dirasakan,
        Coordinates: datanya.Coordinates,
        Shakemap: datanya.Shakemap,
        description: datanya.description,
        address: datanya.address,
        gid: datanya.gid,
        dimensi: datanya.dimensi,
        subdimensi: datanya.subdimensi,
        district: datanya.district,
        subdistrict: datanya.subdistrict,
        category: datanya.category,
        destination: datanya.destination,
        rot: datanya.rot,
        width: datanya.width,
        length: datanya.length,
        flag: datanya.flag,
        date_created: datanya.date_created,
        datetime: datanya.datetime,
        speedTrack: datanya.speedTrack,
        geofenceport_name: datanya.geofenceport_name,
        geofenceport_status: datanya.geofenceport_status,
        openAlert: false,
        openAlertDeparture: false,
        vessel_status: datanya.vessel_status,
        vessel_container: datanya.vessel_container,
        remark: datanya.remark,
        ipman_container_value: datanya.ipman_container_value,
        ipman_activity: datanya.ipman_activity,
        ipman_plant: datanya.ipman_plant,
        ipman_eta: datanya.ipman_eta,
        ipman_ata: datanya.ipman_ata,
        ipman_remark: datanya.ipman_remark,
        ipman_container: datanya.ipman_container,
        fraudid: datanya.fraudid,
        idleTime: datanya.idleTime,
        last_gps: datanya.last_gps,
        last_ais: datanya.last_ais,
        last_cctv: datanya.last_cctv,
        weatherFraud: datanya.weatherFraud,
        windSpeedFraud: datanya.windSpeedFraud,
        first_recorded: datanya.first_recorded,
        eta: datanya.eta,
        source: datanya.source,
        // src: `https://images.marinetraffic.com/collection/${
        //   datanya.ship_id
        // }.webp?size=800`
        src: `https://www.marinetraffic.com/getAssetDefaultPhoto/?photo_size=300&asset_id=${
          datanya.ship_id
        }&asset_type_id=0`
      });
    }
  }

  componentDidMount() {
    var voyage = document.getElementById("add-voyage");

    voyage.onclick = () => {
      this.setState({
        dataVoyage: [],
        dialogVoyage: !this.state.dialogVoyage,
        load: false
      });
      this.props.pushLoader(true);

      fetchVessellistSearch(this.state.call_sign)
        .then(response => {
          if (response != null) {
            this.setState({
              master: response.data.results[0].vessel_captain,
              // dwt: response.data.results[0].dwt,
              grt: response.data.results[0].grt
            });
          }
        })
        .catch(error => {
          console.log(error);
          //this.props.history.push("/pages/login#logout");
        });
    };

    var fav = document.getElementById("add-fav");
    var portdeparture = document.getElementById("port-departure");
    var portarrival = document.getElementById("port-arrival");

    portdeparture.onclick = () => {
      this.setState({ openAlertDeparture: true });
    };
    portarrival.onclick = () => {
      this.setState({ openAlert: true });
    };

    fav.onclick = () => {
      this.props.pushLoader(true);
      const newdata = {
        shipid: this.state.ship_id,
        name: this.state.shipname,
        latitude: this.state.lat,
        longitude: this.state.lon
      };
      pushFavorite(newdata)
        .then(response => {
          this.props.pushLoader(false);
        })
        .catch(error => {
          console.log(error);
          //this.props.history.push("/pages/login#logout");
        });
    };
  }

  handleCloseAlert = () => {
    this.setState({ openAlert: !this.state.openAlert });
  };
  handleCloseAlertDeparture = () => {
    this.setState({ openAlertDeparture: !this.state.openAlertDeparture });
  };

  handleClickOpen = () => {
    this.setState({
      dataVoyage: [],
      dialogVoyage: false
    });
  };

  getActivityName = activity => {
    let activityString;
    switch (activity) {
      case "L":
        activityString = "LOADING";
        break;
      case "D":
        activityString = "DISCHARGING";
        break;
      case "C":
        activityString = "COMMENCING";
        break;
      case "F":
        activityString = "FUELING AT ANCHORAGE";
        break;
      case "G":
        activityString = "FUELING BERTHING";
        break;
      case "I":
        activityString = "CANAL TRANSIT";
        break;
      case "M":
        activityString = "MULTI PURPOSE";
        break;
      case "P":
        activityString = "PASSING";
        break;
      case "O":
        activityString = "OTHER";
        break;
      case "R":
        activityString = "REPAIR";
        break;
      case "T":
        activityString = "TERMINATING";
        break;
      case "W":
        activityString = "WAITING NOMINATION";
        break;
      case "Y":
        activityString = "DELIVERY";
        break;
      case "Z":
        activityString = "REDELIVERY";
        break;
      default:
        activityString = "n/a";
        break;
    }
    return activityString;
  };

  getNameshiptype = shiptype => {
    let shipTypeString;
    switch (shiptype) {
      case 1:
        shipTypeString = "Unspecified Ships";
        break;
      case 2:
        shipTypeString = "Fishing";
        break;
      case 3:
        shipTypeString = "Tugs & Special Craft";
        break;
      case 4:
        shipTypeString = "High Speed Craft";
        break;
      case 5:
        shipTypeString = "Pleasure Craft";
        break;
      case 6:
        shipTypeString = "Passenger Vessel";
        break;
      case 7:
        shipTypeString = "Cargo Vessel";
        break;
      case 8:
        shipTypeString = "Tanker";
        break;

      case 99:
        shipTypeString = "Pertamina";
        break;
      default:
        shipTypeString = "n/a";
        break;
    }
    return shipTypeString;
  };

  convertHtmlToPdf = () => {
    var element = document.getElementById("reportPdf");
    var opt = {
      margin: 1,
      filename: `${this.state.shipname} voyage-report.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "em", format: "letter", orientation: "portrait" },
      pagebreak: { mode: "avoid-all" }
    };

    // New Promise-based usage:
    html2pdf()
      .set(opt)
      .from(element)
      .save();
  };

  renderDatanya = e => {
    if (this.state.dataVoyage.length > 0) {
      return (
        <TableRow>
          <TableCell style={{ padding: 5 }}>
            <small>
              {this.getActivityName(e.activity)} {"(" + e.activity + ")"}
            </small>
          </TableCell>
          <TableCell style={{ padding: 5 }}>
            <small>{e.portname}</small>
          </TableCell>
          <TableCell style={{ padding: 5 }}>
            <small>
              {e.ald_add != null && e.ald_add != "" && e.ald_add != "-"
                ? moment(e.ald_add).format("DD-MM-YYYY")
                : "no data"}
            </small>
          </TableCell>
          <TableCell style={{ padding: 5 }}>
            <small>{e.cargoname != "" ? e.cargoname : "no data"}</small>
          </TableCell>
        </TableRow>
      );
    }
  };

  renderButtonVoyage = () => {
    if (this.state.buttonvoyage == true) {
      return (
        <Button
          color="primary"
          variant="contained"
          startIcon={<Lists />}
          id="add-voyage"
          onClick={() => {
            this.setState({ dialogVoyage: !this.state.dialogVoyage });

            fetchVessellistSearch(this.state.call_sign)
              .then(response => {
                if (response != null) {
                  this.setState({
                    master: response.data.results[0].vessel_captain,
                    // dwt: response.data.results[0].dwt,
                    grt: response.data.results[0].grt
                  });
                }
              })
              .catch(error => {
                console.log(error);
                //this.props.history.push("/pages/login#logout");
              });
          }}
        >
          <small>Voyage</small>
        </Button>
      );
    } else {
      return <div id="add-voyage" />;
    }
  };

  renderDataCargo = (e, index) => {
    if (this.state.dataVoyage.length > 0) {
      if (e.activity == "L") {
        return (
          <Grid container justify="center">
            <Grid item xs={12} md={12}>
              <Typography align="left" style={{ paddingLeft: "30px" }}>
                Cargo Actual ({this.getActivityName(e.activity)}) {e.portname}
              </Typography>
              <br />
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              style={{ paddingLeft: "30px", paddingRight: "30px" }}
            >
              <TableContainer>
                <Table size="small" aria-label="a dense table" padding="none">
                  <TableHead>
                    <TableRow>
                      <TableCell>Item</TableCell>
                      <TableCell>Grade</TableCell>
                      <TableCell>Doc Number</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell>Value</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody striped={true}>
                    <TableRow>
                      <TableCell style={{ padding: 5 }}>
                        <small>Bill of Lading</small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>{e.cargoname}</small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.billofladingnumber != "" &&
                          e.billofladingnumber != null
                            ? e.billofladingnumber
                            : "no data"}
                        </small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.billofladingdate != null &&
                          e.billofladingdate != "" &&
                          e.billofladingdate != "-"
                            ? moment(e.billofladingdate).format("DD-MM-YYYY")
                            : "no data"}
                        </small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.BillOfLadingQuantity != ""
                            ? e.BillOfLadingQuantity
                            : "0"}{" "}
                          {"(" + e.uom + ")"}
                        </small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ padding: 5 }}>
                        <small>New Bill of Lading</small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>{e.cargoname}</small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.billofladingnumber != "" &&
                          e.billofladingnumber != null
                            ? e.billofladingnumber
                            : "no data"}
                        </small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.sfaldate != null &&
                          e.sfaldate != "" &&
                          e.sfaldate != "-"
                            ? moment(e.sfaldate).format("DD-MM-YYYY")
                            : "no data"}
                        </small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.newbilloflading != "" &&
                          e.newbilloflading != undefined
                            ? e.newbilloflading
                            : "0"}{" "}
                          {"(" + e.uom + ")"}
                        </small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ padding: 5 }}>
                        <small>Ship Figure After Loading</small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>{e.cargoname}</small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.billofladingnumber != "" &&
                          e.billofladingnumber != null
                            ? e.billofladingnumber
                            : "no data"}
                        </small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.sfaldate != null &&
                          e.sfaldate != "" &&
                          e.sfaldate != "-"
                            ? moment(e.sfaldate).format("DD-MM-YYYY")
                            : "no data"}
                        </small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.sfalklobs != "" ? e.sfalklobs : "0"}{" "}
                          {"(" + e.uom + ")"}
                        </small>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <br />
              <br />
            </Grid>
          </Grid>
        );
      } else if (e.activity == "D" || e.activity == "M") {
        return (
          <Grid container justify="center">
            <Grid item xs={12} md={12}>
              <Typography align="left" style={{ paddingLeft: "30px" }}>
                Cargo Actual ({this.getActivityName(e.activity)}) {e.portname}
              </Typography>
              <br />
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              style={{ paddingLeft: "30px", paddingRight: "30px" }}
            >
              <TableContainer>
                <Table size="small" aria-label="a dense table" padding="none">
                  <TableHead>
                    <TableRow>
                      <TableCell>Item</TableCell>
                      <TableCell>Grade</TableCell>
                      <TableCell>Doc Number</TableCell>
                      <TableCell>Date</TableCell>
                      <TableCell>Value</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody striped={true}>
                    <TableRow>
                      <TableCell style={{ padding: 5 }}>
                        <small>Bill of Lading</small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>{e.cargoname}</small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.billofladingnumber != "" &&
                          e.billofladingnumber != null
                            ? e.billofladingnumber
                            : "no data"}
                        </small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.billofladingdate != null &&
                          e.billofladingdate != "" &&
                          e.billofladingdate != "-"
                            ? moment(e.billofladingdate).format("DD-MM-YYYY")
                            : "no data"}
                        </small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.BillOfLadingQuantity != ""
                            ? e.BillOfLadingQuantity
                            : "0"}{" "}
                          {"(" + e.uom + ")"}
                        </small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ padding: 5 }}>
                        <small>New Bill of Lading</small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>{e.cargoname}</small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.billofladingnumber != "" &&
                          e.billofladingnumber != null
                            ? e.billofladingnumber
                            : "no data"}
                        </small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.sfbddate != null &&
                          e.sfbddate != "" &&
                          e.sfbddate != "-"
                            ? moment(e.sfbddate).format("DD-MM-YYYY")
                            : "no data"}
                        </small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.newbilloflading != "" &&
                          e.newbilloflading != undefined
                            ? e.newbilloflading
                            : "0"}{" "}
                          {"(" + e.uom + ")"}
                        </small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ padding: 5 }}>
                        <small>Ship Figure After Discharging (SFAD)</small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>{e.cargoname}</small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.billofladingnumber != "" &&
                          e.billofladingnumber != null
                            ? e.billofladingnumber
                            : "no data"}
                        </small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.sfaddate != null &&
                          e.sfaddate != "" &&
                          e.sfaddate != "-"
                            ? moment(e.sfaddate).format("DD-MM-YYYY")
                            : "no data"}
                        </small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.sfalklobs != "" ? e.sfalklobs : "0"}{" "}
                          {"(" + e.uom + ")"}
                        </small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ padding: 5 }}>
                        <small>Ship Figure Before Discharging (SFBD)</small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>{e.cargoname}</small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.billofladingnumber != "" &&
                          e.billofladingnumber != null
                            ? e.billofladingnumber
                            : "no data"}
                        </small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.sfbddate != null &&
                          e.sfbddate != "" &&
                          e.sfbddate != "-"
                            ? moment(e.sfbddate).format("DD-MM-YYYY")
                            : "no data"}
                        </small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.sfbdklobs != "" ? e.sfbdklobs : "0"}{" "}
                          {"(" + e.uom + ")"}
                        </small>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell style={{ padding: 5 }}>
                        <small>Actual Received (AR)</small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>{e.cargoname}</small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.billofladingnumber != "" &&
                          e.billofladingnumber != null
                            ? e.billofladingnumber
                            : "no data"}
                        </small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.ardate != null && e.ardate != "" && e.ardate != "-"
                            ? moment(e.ardate).format("DD-MM-YYYY")
                            : "no data"}
                        </small>
                      </TableCell>
                      <TableCell style={{ padding: 5 }}>
                        <small>
                          {e.arklobs != "" ? e.arklobs : "0"}{" "}
                          {"(" + e.uom + ")"}
                        </small>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
              <br />
              <br />
            </Grid>
          </Grid>
        );
      }
    }
  };

  render() {
    const { classes } = this.props;

    return (
      <div>
        <div
          style={{
            backgroundColor: "#192964"
          }}
        >
          <div style={{ padding: "10px" }}>
            <font color="white">
              <b>{this.state.name}</b>
            </font>
          </div>
        </div>
        <div hidden={this.state.geomtype === "vessel" ? false : true}>
          <div>
            <NavLink to={"/cctv-history"}>
              <div className={classes.container}>
                <img
                  id={this.state.ship_id}
                  className={classes.image}
                  src={this.state.src}
                  // ref={img => (this.img = img)}
                  onError={() => this.setState({ src: Image })}
                />
                <div className={classes.middle}>
                  <div
                    className={classes.text}
                    onClick={() => {
                      this.props.pushCctvhistoris([]);
                      this.props.pushLoader(true);
                      fetchSearchCctvactreport(this.state.shipname)
                        .then(response => {
                          let data = response.data.results[0];
                          if (response !== null) {
                            let start = [
                              data.ch1,
                              data.ch2,
                              data.ch3,
                              data.ch4,
                              data.ch5
                            ];
                            start.sort((a, b) => a - b);
                            let end = [
                              data.ch1,
                              data.ch2,
                              data.ch3,
                              data.ch4,
                              data.ch5
                            ];
                            end.sort((a, b) => b - a);
                            if (start[0] !== "undefined") {
                              this.props.pushCctvMap([
                                this.state.shipname,
                                this.state.call_sign,
                                start[0],
                                end[0]
                              ]);
                            } else {
                              this.props.pushCctvMap([
                                this.state.shipname,
                                this.state.call_sign,
                                start[1],
                                end[1]
                              ]);
                            }
                          }
                          this.props.pushLoader(false);
                        })
                        .catch(error => {
                          this.props.pushCctvMap([
                            "no cctv found",
                            this.state.shipname,
                            this.state.call_sign
                          ]);
                          //this.props.history.push("/pages/login#logout");
                        });
                    }}
                  >
                    Open CCTV
                  </div>
                </div>
              </div>
            </NavLink>
          </div>

          <AppBar position="static">
            <Toolbar style={{ minHeight: 43 }}>
              <IconButton
                edge="start"
                size="small"
                className={classes.menuButton}
                color="inherit"
                aria-label="menu"
                id="popup-detail"
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" className={classes.title} />
              <div align="right" style={{ width: "100%" }}>
                <Button
                  color="primary"
                  variant="contained"
                  startIcon={<BookmarkBorderIcon />}
                  id="add-fav"
                >
                  <small>Bookmark</small>
                </Button>
              </div>
              <div align="right" style={{ width: "100%" }}>
                {this.renderButtonVoyage()}
              </div>
            </Toolbar>
          </AppBar>

          <NavPills
            color="white"
            alignCenter={true}
            style={{ width: 100 }}
            tabs={[
              {
                tabButton: (
                  <div
                    style={{
                      // backgroundColor:
                      //   this.state.alertVoyage != true ? "#FFD700" : "none",
                      padding: "4px",
                      paddingLeft: "8px",
                      fontSize: "14px"
                    }}
                  >
                    <small
                      style={{
                        display: "flex",
                        color:
                          this.state.alertVoyage != true ? "red" : "#3f51b5"
                      }}
                    >
                      {" "}
                      INFO
                      <div
                        hidden={this.state.alertVoyage}
                        style={{ paddingLeft: "2px" }}
                      >
                        <NewTooltip
                          title={this.state.alertText}
                          aria-label="add"
                        >
                          <ErrorOutlineIcon
                            style={{ fontSize: "13px" }}
                            color="secondary"
                          />
                        </NewTooltip>
                      </div>
                    </small>
                  </div>
                ),
                tabContent: <Tabinfo datanya={this.state} />
              },
              {
                tabButton: "Track",
                tabContent: <Tabtrack datanya={this.state} />
              }
            ]}
          />
        </div>
        <div
          hidden={this.state.geomtype === "gempa" ? false : true}
          style={{ height: 400 }}
        >
          <TableContainer>
            <Table size="small" aria-label="a dense table">
              <TableBody striped={true}>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Tanggal</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.Tanggal} </small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Jam</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.Jam} </small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>DateTime</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.DateTime}</small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Coordinates</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.Coordinates}</small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Lintang</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.Lintang}</small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Bujur</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.Bujur}</small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Magnitude</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.Magnitude}</small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Kedalaman</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.Kedalaman} </small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Wilayah</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.Wilayah} </small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Potensi</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.Potensi} </small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Dirasakan</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.Dirasakan} </small>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div hidden={this.state.geomtype === "port" ? false : true}>
          <div>
            <img
              height="200"
              width="100%"
              // src={`https://images.marinetraffic.com/collection/${
              //   this.state.gid
              // }.webp?size=800`}
              src={`https://www.marinetraffic.com/getAssetDefaultPhoto/?photo_size=300&asset_id=${
                this.state.gid
              }&asset_type_id=0`}
              ref={img => (this.img = img)}
              onError={() =>
                (this.img.src = require(`../../assets/img/default.png`))
              }
            />
          </div>
          <div style={{ height: 300 }}>
            <TableContainer>
              <Table size="small" aria-label="a dense table">
                <TableBody striped={true}>
                  <TableRow>
                    <TableCell component="th" scope="row">
                      {" "}
                      <small>Type: {this.state.geomtype}</small>
                    </TableCell>
                    <TableCell align="right">
                      <small>PORTID: {this.state.gid} </small>
                    </TableCell>
                  </TableRow>

                  <TableRow style={{ background: "#192964" }}>
                    <TableCell component="th" scope="row">
                      {" "}
                      <small style={{ color: "#ffff" }}>
                        <span id="port-arrival" style={{ cursor: "pointer" }}>
                          Port Arrival List >>{" "}
                        </span>
                      </small>
                      <Dialog
                        maxWidth={"md"}
                        open={this.state.openAlert}
                        aria-labelledby="form-dialog-title"
                      >
                        <DialogTitle id="form-dialog-title">
                          Port Arrival List
                        </DialogTitle>
                        <DialogContent>
                          <Grid item xs={12} sm={12} md={12}>
                            <Arrivallist gid={this.state.gid} />
                          </Grid>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={this.handleCloseAlert}
                            color="danger"
                            round
                          >
                            Close
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </TableCell>
                    <TableCell align="right">
                      <small style={{ color: "#ffff" }}>
                        {" "}
                        {this.state.current_offset}{" "}
                      </small>
                    </TableCell>
                  </TableRow>
                  <TableRow style={{ background: "#192964" }}>
                    <TableCell component="th" scope="row">
                      {" "}
                      <small style={{ color: "#ffff" }}>
                        <span id="port-departure" style={{ cursor: "pointer" }}>
                          Port Departure List >>{" "}
                        </span>
                      </small>
                      <Dialog
                        maxWidth={"md"}
                        open={this.state.openAlertDeparture}
                        aria-labelledby="form-dialog-title"
                      >
                        <DialogTitle id="form-dialog-title">
                          Port Departure List
                        </DialogTitle>
                        <DialogContent>
                          <Grid item xs={12} sm={12} md={12}>
                            <Departurelist gid={this.state.gid} />
                          </Grid>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={this.handleCloseAlertDeparture}
                            color="danger"
                            round
                          >
                            Close
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </TableCell>
                  </TableRow>
                  <TableRow style={{ background: "#192964" }}>
                    <TableCell component="th" scope="row">
                      {" "}
                      <small style={{ color: "#ffff" }}>
                        Country: {this.state.district}
                      </small>
                    </TableCell>
                    <TableCell align="right">
                      <small style={{ color: "#ffff" }}>
                        Location: {this.state.address}{" "}
                      </small>
                    </TableCell>
                  </TableRow>
                  <TableRow style={{ background: "#192964" }}>
                    <TableCell component="th" scope="row" colSpan={2}>
                      {" "}
                      <small style={{ color: "#ffff" }}>
                        More Info :{this.state.description}{" "}
                      </small>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
        <div
          hidden={this.state.name === "Track" ? false : true}
          style={{ height: 400 }}
        >
          <TableContainer>
            <Table size="small" aria-label="a dense table">
              <TableBody striped={true}>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Time</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.datetime} </small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>lon</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.lon} </small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>lat</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.lat}</small>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div
          hidden={this.state.geomtype === "fraud" ? false : true}
          style={{ height: 400 }}
        >
          <div>
            <img
              id={this.state.ship_id}
              className={classes.image}
              src={this.state.src}
              // ref={img => (this.img = img)}
              onError={() => this.setState({ src: Image })}
            />
          </div>
          <TableContainer>
            <Table size="small" aria-label="a dense table">
              <TableBody striped={true}>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Ship Name</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.shipname} </small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Speed</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.speed} </small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Checking Time</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.date_created} </small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Idle Time (hours)</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.idleTime}</small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Last GPS</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.last_gps}</small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Last AIS</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.last_ais}</small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Last CCTV</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.last_cctv}</small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Weather</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.weatherFraud}</small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>Wind Speed</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.windSpeedFraud} </small>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component="th" scope="row">
                    {" "}
                    <small>First Recorded</small>
                  </TableCell>
                  <TableCell align="right">
                    <small>{this.state.first_recorded} </small>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>

        <Dialog
          aria-labelledby="simple-dialog-title"
          open={this.state.dialogVoyage}
          onClose={this.handleClickOpen}
          maxWidth={"md"}
          fullWidth={true}
        >
          <DialogTitle id="simple-dialog-title">
            Voyage {this.state.shipname} ({this.state.call_sign})
          </DialogTitle>
          <DialogContent>
            <div hidden={this.state.report == true ? false : true}>
              <Button
                color="primary"
                variant="contained"
                onClick={this.convertHtmlToPdf}
              >
                Download Report
              </Button>
              <div id="reportPdf">
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <div style={{ justifyContent: "center" }}>
                      <Typography
                        style={{
                          textAlign: "center",
                          flex: 1,
                          fontSize: "28px",
                          fontWeight: 500
                        }}
                      >
                        <font>VOYAGE REPORT</font>
                      </Typography>
                      <br />
                    </div>
                  </GridItem>
                  <Grid item xs={12}>
                    <Grid
                      container
                      style={{ paddingLeft: "30px", paddingRight: "30px" }}
                    >
                      <Grid item xs={12} md={6}>
                        <Typography>
                          Vessel Name: {this.state.shipname}
                        </Typography>
                        <Typography>Flag: {this.state.flag}</Typography>
                        <Typography>Master: {this.state.master}</Typography>
                        <Typography>
                          Date:{" "}
                          {this.state.modified != null &&
                          this.state.modified != "" &&
                          this.state.modified != "-"
                            ? moment(this.state.modified).format(
                                "DD-MM-YYYY HH:mm:ss"
                              ) +
                              " " +
                              "WIB"
                            : "no data"}
                        </Typography>
                        <Typography>SN: {this.state.shipnumber}</Typography>
                        <br />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography align="right">
                          Voyage Order: {this.state.voyage_number}
                        </Typography>
                        <Typography align="right">
                          GRT: {this.state.grt}
                        </Typography>
                        <Typography align="right">
                          DWT: {this.state.dwt}
                        </Typography>
                        <Typography align="right">
                          Type of Vessel:{" "}
                          {this.getNameshiptype(this.state.typenya)}
                        </Typography>
                        <Typography
                          align="right"
                          style={{ color: "red" }}
                          hidden={this.state.alertVoyage}
                        >
                          Voyage is not updated yet from IMIS
                        </Typography>
                        <br />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container justifyContent="center">
                      <Grid item xs={12} md={10}>
                        <TableContainer>
                          <Table
                            size="small"
                            aria-label="a dense table"
                            padding="none"
                          >
                            <TableHead>
                              <TableRow>
                                <TableCell>Activity</TableCell>
                                <TableCell>Port</TableCell>
                                <TableCell>ALD/ADD</TableCell>
                                <TableCell>Cargo</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody striped={true}>
                              {this.state.dataVoyage.map(this.renderDatanya)}
                            </TableBody>
                          </Table>
                        </TableContainer>
                        <br />
                        <br />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <Typography
                      align="left"
                      style={{
                        paddingLeft: "30px",
                        fontSize: 14,
                        fontWeight: 500
                      }}
                    >
                      Map
                    </Typography>
                    <br />
                  </Grid>
                  <Voyage
                    voyageName={0}
                    shipId={this.state.ship_id}
                    start={this.state.startdate}
                    end={this.state.enddate}
                  />
                  <Grid item xs={12}>
                    <br />
                    <br />
                    {this.state.dataVoyage.map(this.renderDataCargo)}
                  </Grid>
                </GridContainer>
              </div>

              {/* <NavPills
                color="white"
                alignCenter={true}
                style={{ width: 100 }}
                tabs={this.state.tabnya}
              /> */}
            </div>
            <div hidden={this.state.report == false ? false : true}>
              {this.state.load == false ? (
                <Typography>Loading...</Typography>
              ) : (
                <Typography>No Data</Typography>
              )}
              {/* <Typography>Loading..</Typography> */}
            </div>
            {/* <div hidden={this.state.report == false ? false : true}>
              <Typography>No Data</Typography>
            </div> */}
          </DialogContent>
        </Dialog>
      </div>
    );
  }
}

Rightpanel.propTypes = {
  content: PropTypes.func,
  pushLoader: PropTypes.bool,
  pushCctvMap: PropTypes.array,
  pushCctvhistoris: PropTypes.array
};

function mapStateToProps(state) {
  return {
    blocking: state.loader,
    allStateMapmaster: state.allStateMapmaster
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    {
      pushLoader,
      pushCctvMap,
      pushCctvhistoris
    }
  )(withStyles(styles)(Rightpanel))
);
